import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { GlobalAccess as View } from '@views';
import { getLocations } from '@store/location/duck';
import { trackEvent } from '@utils/mixpanel';
import { getAccessRequestsList } from '@store/globalAccess/duck';
import { LOADING } from '@constants/requestPhase';

const GlobalAccess = () => {
  const { requests, getAccessRequestsListPhase, requestAccessPhase, editAccessRequestPhase, cancelAccessRequestPhase } =
    useSelector(store => store.globalAccessStore);

  const dispatch = useDispatch();

  useEffect(() => {
    const pageTitle = 'Mindspace: Global Access';
    document.title = pageTitle;

    window.gtag('event', 'page_view', {
      page_title: pageTitle,
    });

    trackEvent('Page Viewed', {
      Page: 'Global Access',
    });
  }, []);

  useEffect(() => {
    dispatch(getLocations({ search: '', globalAccessAvailable: true }));

    dispatch(getAccessRequestsList());
  }, []);

  return (
    <View
      requests={requests}
      isLoading={
        getAccessRequestsListPhase === LOADING ||
        requestAccessPhase === LOADING ||
        editAccessRequestPhase === LOADING ||
        cancelAccessRequestPhase === LOADING
      }
    />
  );
};

export default GlobalAccess;
